import { render, staticRenderFns } from "./CloseIcon.vue?vue&type=template&id=2a85f39c&scoped=true&"
import script from "./CloseIcon.vue?vue&type=script&lang=js&"
export * from "./CloseIcon.vue?vue&type=script&lang=js&"
import style0 from "./CloseIcon.vue?vue&type=style&index=0&id=2a85f39c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a85f39c",
  null
  
)

export default component.exports